import {forwardRef, type ReactNode} from 'react';
import {useDockStyle} from './callDock';

export type CallBubbleTone = 'call' | 'dialer';

interface CallBubbleProps {
    readonly tone: CallBubbleTone;
    readonly label: string;
    readonly urgent?: boolean;
    readonly testId?: string;
    readonly placement?: 'floating' | 'inline';
    readonly children: ReactNode;
}

const TONES: Record<CallBubbleTone, string> = {
    call: 'phq-call-ui border-[var(--phq-call-line)] bg-[var(--phq-call-canvas)] [background-image:var(--phq-call-stage-gradient)] p-4 phq-call-shadow-overlay',
    dialer: 'phq-call-light border-[var(--phq-call-line)] bg-[var(--phq-call-surface)] phq-call-shadow-overlay',
};

const BUBBLE_SIZE = {width: 320};

export const CallBubble = forwardRef<HTMLElement, CallBubbleProps>(({tone, label, urgent = false, testId, placement = 'floating', children}, ref) => {
    const docked = useDockStyle(BUBBLE_SIZE);
    const floating = placement === 'floating';
    return (
        <section
            ref={ref}
            role={urgent ? 'alert' : 'region'}
            aria-live={urgent ? 'assertive' : 'polite'}
            aria-label={label}
            data-testid={testId ?? 'call-bubble'}
            data-tone={tone}
            style={floating ? docked : undefined}
            className={`phq-call-enter ${floating ? 'fixed z-[60]' : 'relative'} flex w-[320px] flex-col overflow-hidden rounded-[20px] border ${TONES[tone]}`}
        >
            {children}
        </section>
    );
});

CallBubble.displayName = 'CallBubble';
